export default [
    {
        path: '/unfinds',
        name: 'unfind',
        meta: {login: false},
        component: () => import(/* webpackChunkName: 'Unfind' */ './index.vue'),
    }
  ]